interface Props {
  rows: number
  columns: number
  mainContainerStyle?: string
  dotsStyle?: string
}

const DotsCollection = ({
  rows,
  columns,
  mainContainerStyle,
  dotsStyle,
}: Props) => {
  return (
    <div className={`flex flex-col items-center ${mainContainerStyle}`}>
      {Array.from({ length: rows }, (_, rIdx) => (
        <div key={rIdx} className="flex">
          {Array.from({ length: columns }, (_, colIdx) => (
            <div
              key={colIdx}
              className={`ml-1 mt-1 lg:ml-1 lg:mt-1 rounded-full ${dotsStyle}`}
            />
          ))}
        </div>
      ))}
    </div>
  )
}

export default DotsCollection
